import type { ReactElement } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { useViewport } from "@primitives/index";
import { SettingsGroup, SettingsRow } from "@compositions/index";
import { SettingsPage } from "./SettingsPage";
import { SETTINGS_NAV_ENTRIES } from "./settingsNav";

/**
 * The `/settings` index. On `medium`+ the nav is always visible, so the index
 * redirects to the first category. On `compact` it is the category list.
 */
export function SettingsIndex(): ReactElement {
    const { isAtLeast } = useViewport();
    const navigate = useNavigate();

    if (isAtLeast("medium")) {
        return <Navigate to="appearance" replace />;
    }

    return (
        <SettingsPage title="Settings">
            <SettingsGroup testId="settings-categories">
                {SETTINGS_NAV_ENTRIES.map((entry) => {
                    const Icon = entry.icon;
                    return (
                        <SettingsRow
                            key={entry.id}
                            variant="navigation"
                            leading={<Icon size={16} strokeWidth={2} />}
                            label={entry.label}
                            description={entry.description}
                            onSelect={() => void navigate(entry.to)}
                            testId={`settings-category-${entry.id}`}
                        />
                    );
                })}
            </SettingsGroup>
        </SettingsPage>
    );
}
